import type { PortalRole, PortalPermission } from '../types/api.js';
import { checkPermission, PORTAL_PERMISSIONS } from '@cortex/core-types';

/**
 * 権限定義（@cortex/core-types から中央集権管理）
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 権限マップ定数。@cortex/core-typesのPORTAL_PERMISSIONSを再エクスポート
 * @graph-connects none
 */
export const PERMISSIONS = PORTAL_PERMISSIONS;

export type Permission = PortalPermission;

/**
 * ユーザーが指定された権限を持っているかチェック（ロール + チーム条件対応）
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business ユーザーロール・チーム名とPermissionキーを照合し、権限の有無を判定
 * @graph-connects none
 */
export function hasPermission(
  userRoles: PortalRole[] | undefined,
  permission: Permission,
  userTeamName?: string,
): boolean {
  return checkPermission(userRoles, permission, userTeamName);
}

/**
 * ユーザーの保持ロールのいずれかが指定ロールに含まれるかチェック（existential）
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 保持ロール配列のいずれかが指定ロール配列に含まれるか判定
 * @graph-connects none
 */
export function hasRole(
  userRoles: PortalRole[] | undefined,
  roles: readonly PortalRole[],
): boolean {
  if (!userRoles || userRoles.length === 0) return false;
  return userRoles.some((role) => roles.includes(role));
}
